exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-truck {\n  width: 32px;\n  height: 32px;\n}\n", ""]);

// exports
